import { useCallback, type ComponentType } from 'react';
import { useSyncExternalStore } from 'react';
import type { UIRegistry } from '../../core/UIRegistry';

/**
 * React hook that returns components registered for a UI slot.
 * Re-renders when the slot contents change.
 */
export function usePluginSlot(registry: UIRegistry, slot: string): readonly ComponentType[] {
  const subscribe = useCallback(
    (onStoreChange: () => void) => registry.subscribe(onStoreChange),
    [registry],
  );

  const getSnapshot = useCallback(
    () => registry.getComponents(slot) as readonly ComponentType[],
    [registry, slot],
  );

  return useSyncExternalStore(subscribe, getSnapshot);
}
